// extracted by mini-css-extract-plugin
export default {"container":"SpecialRequestResponse_container__5RY40","alert":"SpecialRequestResponse_alert__Zc6lk","center":"SpecialRequestResponse_center__Gq2+x"};